import React from "react";
import "./styles.scss";

const Index = (props) => (
  <>
    <div className={`slider-spot-wrapper d-flex`}>
      {props.noOfSpot === 2 && (
        <>
          <div className={`spot ${props.active === 1 ? "spot_active" : ""}`} />
          <div className={`spot ${props.active === 2 ? "spot_active" : ""}`} />
        </>
      )}

      {props.noOfSpot === 5 && (
        <>
          <div className={`spot ${props.active === 1 ? "spot_active" : ""}`} />
          <div className={`spot ${props.active === 2 ? "spot_active" : ""}`} />
          <div className={`spot ${props.active === 3 ? "spot_active" : ""}`} />
          <div className={`spot ${props.active === 4 ? "spot_active" : ""}`} />
          <div className={`spot ${props.active === 5 ? "spot_active" : ""}`} />
        </>
      )}
    </div>
  </>
);

export default Index;
